import type { GameState } from "./types";

const stageLabels = {
  ripped: "Ripped",
  tidy: "Tidy",
  sparkly: "Sparkly",
  royal: "Royal"
} as const;

export interface Hud {
  render(state: GameState): void;
  announce(title: string, copy: string): void;
}

export function createHud(): Hud {
  const candyCount = requireElement("#candy-count");
  const clothesCount = requireElement("#clothes-count");
  const outfitStage = requireElement("#outfit-stage");
  const messageTitle = requireElement("#message-title");
  const messageCopy = requireElement("#message-copy");

  return {
    render(state: GameState): void {
      candyCount.textContent = `Candy ${state.candy}/8`;
      clothesCount.textContent = `Clothes ${state.clothes}/5`;
      outfitStage.textContent = `Dress: ${stageLabels[state.outfitStage]}`;
    },
    announce(title: string, copy: string): void {
      messageTitle.textContent = title;
      messageCopy.textContent = copy;
    }
  };
}

function requireElement(selector: string): HTMLElement {
  const element = document.querySelector<HTMLElement>(selector);

  if (!element) {
    throw new Error(`Missing HUD element ${selector}`);
  }

  return element;
}
